<template>
    <Teleport to="#modals">
        <div ref="modal" class="modal fade" v-bind="$attrs" :data-bs-backdrop="backdrop ? 'static' : false" :data-bs-keyboard="keyboard" :data-bs-focus="focus" tabindex="-1" style="user-select:none;" aria-hidden="false">
            <div class="modal-dialog" :class="modalSize">
                <div ref="modalContent" class="modal-content">
                    <div class="modal-header  d-flex justify-content-end">
                        <slot name="header">
                          <h5 class="modal-title flex-fill" v-if="C.Str(title).length > 0">{{ title }}</h5>
                          <a href="javascript:void(0)" type="button" @click="hide()">
                              <i class="icon icon-xmark"></i>
                          </a>
                        </slot>
                    </div>
                    <div class="modal-body" :options="{ suppressScrollX: true }">
                        <div class="d-flex justify-content-center align-items-center">
                            <slot></slot>
                        </div>
                    </div>
                    <div class="modal-footer border-0">
                        <slot name="footer">
                            <button type="button" class="btn btn-primary" @click="hide()">Tamam</button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>
<script>
import { ref, onMounted, onBeforeUnmount, watch, nextTick } from 'vue';

import { Modal } from "bootstrap";
import { appData } from '@/helpers/global';

export default {
    name: "SmartModal",
    components: {
    },
    inheritAttrs: false,
    props: {
        title: String,
        backdrop: {
            type: Boolean,
            default: true,
        },
        keyboard: {
            type: Boolean,
            default: false,
        },
        focus: {
            type: Boolean,
            default: true,
        },
        size: {
            type: String,
            default:"modal-dialog-centered modal-dialog-scrollable modal-fullscreen-md-down",
        },
    },
    setup(props, { expose }) {
        const modalSize = ref(props.size);
        const modal = ref(null);
        const modalContent = ref(null);
        let modalInstance = null;
        onMounted(() => {
            //modalInstance = new Modal(modal.value, {
            //    backdrop: 'static',
            //    keyboard: false
            //});
            modalInstance = new Modal(modal.value, {
                backdrop: props.backdrop ? 'static' : false,
                keyboard: props.keyboard,
                focus: false,
            });
        });
        onBeforeUnmount(() => {
            if (modalInstance) {
                modalInstance.dispose();
            }
        });
        const show = () => {
            try {
                if(modalInstance) {
                    modalInstance.show();
                }
            }
            catch(ex) { console.warn(ex.message); }
        };
        const hide = () => {
            try {
                if(modalInstance) {
                    modalInstance.hide();
                }
            }
            catch(ex) { console.warn(ex.message); }
        };
        const scrollTop = (top) => {
            if (modalContent.value) {
                nextTick(() => {
                    const body = modalContent.value.querySelector(".modal-body");
                    if (body) {
                        appData.fn.scrollStart(body, top);
                        appData.fn.scrollLeft(body, 0);
                    }
                });
            }
        };
        expose({ modalContent, show, hide, scrollTop });

        watch(() => props.size, (n, o) => {
            if(n != o) {
                modalSize.value = n; 
            }
        }, { deep: true });
        return { modal, modalContent, show, hide, scrollTop, modalSize };
    }
};
</script>
